angular.module("vgresiduos").controller("OrganizationUnitDocumentListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "unidade/documentos");
		};
	}
]);
